import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './lib/i18n';
import App from './app';
import { installHmrLoopGuard } from './lib/hmr-loop-guard';
import { installKeyboardNavTracking } from './lib/keyboard-nav';
import { installLoadRecorder } from './lib/load-recorder';
import { installUndoRecorder } from './lib/undo-recorder';
import './styles/globals.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(
    'Root element not found. Ensure index.html contains <div id="root"></div>'
  );
}

installKeyboardNavTracking();
// Development only, and a no-op in a production build — see `undo-recorder`.
installUndoRecorder();
installLoadRecorder();
installHmrLoopGuard();

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
